import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import Home from './components/home/layout/Home';

import Sidebar from './components/utils/Sidebar';
import ProtectedRoute from './components/auth/ProtectedRoute';

import ClearIncome from './components/income/layout/ClearIncome';
import EditIncome from './components/income/layout/EditIncome';
import ImportIncome from './components/income/layout/ImportIncome';
import IncomeDashboard from './components/income/layout/DashIncome';
import HomeIncome from './components/income/layout/HomeIncome';

import HomeExpenses from './components/expenses/layout/HomeExpenses';
import DashExpenses from './components/expenses/layout/DashExpenses';
import ClearExpenses from './components/expenses/layout/ClearExpenses';
import EditExpenses from './components/expenses/layout/EditExpenses';
import ImportExpenses from './components/expenses/layout/ImportExpenses';
import PreviewExpenses from './components/expenses/layout/PreviewExpenses';

import ClearInvestments from './components/investments/layout/ClearInvestments';
import EditInvestments from './components/investments/layout/EditInvestments';
import ImportInvestments from './components/investments/layout/ImportInvestments';
import InvestmentsMain from './components/investments/layout/MainInvestments';
import InvestmentsDashboard from './components/investments/layout/DashInvestments';
import CryptoDashboard from './components/investments/layout/dashboard/CryptoDash';
import StockDashboard from './components/investments/layout/dashboard/StockDash';
import TesouroDiretoDashboard from './components/investments/layout/dashboard/TesouroDash';
import InvestmentsList from './components/investments/layout/ListInvestments';
import StockImport from './components/investments/layout/import/StockImport';
import DigitalCoinImport from './components/investments/layout/import/CryptoImport';
import TesouroDiretoImport from './components/investments/layout/import/TesouroImport';

import Account from './components/account/layout/Account';
import Login from './components/login/layout/Login';
import Register from './components/login/layout/Register';

import Goals from './components/goals/layout/Goals';
import Dashboard from './components/dashboard/layout/Dashboard';

import Cashflow from './components/cashflow/layout/Cashflow';
import EditCashflow from './components/cashflow/layout/EditCashflow';

import { Toaster } from "./components/ui/toaster"
import { getCsrfToken } from './components/utils/csrf';

const App: React.FC = () => {
  useEffect(() => {
    getCsrfToken().catch(console.error);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/favicon.ico" element={<Navigate to="/public/favicon.ico" replace />} />

        <Route path="/*" element={
          <ProtectedRoute>
            <div className="flex h-screen overflow-hidden">
              <Sidebar />
              <div className="flex-1 ml-[60px]">
                <main className="h-full overflow-auto bg-gray-900">
                  <Routes>
                    {/* home */}
                    <Route path="/home" element={<Home />} />
                    {/* income */}
                    <Route path="/income/clear" element={<ClearIncome />} />
                    <Route path="/income/edit" element={<EditIncome />} />
                    <Route path="/income/import" element={<ImportIncome />} />
                    <Route path="/income/dashboard" element={<IncomeDashboard />} />
                    <Route path="/income" element={<HomeIncome />} />
                    {/* expenses */}
                    <Route path="/expenses/" element={<HomeExpenses />} />
                    <Route path="/expenses/dashboard" element={<DashExpenses />} />
                    <Route path="/expenses/clear" element={<ClearExpenses />} />
                    <Route path="/expenses/edit" element={<EditExpenses />} />
                    <Route path="/expenses/import" element={<ImportExpenses />} />
                    <Route path="/expenses/preview" element={<PreviewExpenses />} />
                    {/* investments */}
                    <Route path="/investments" element={<InvestmentsMain />} />
                    <Route path="/investments/dashboard" element={<InvestmentsDashboard />} />
                    <Route path="/investments/dashboard/crypto" element={<CryptoDashboard />} />
                    <Route path="/investments/dashboard/stock" element={<StockDashboard />} />
                    <Route path="/investments/dashboard/tesouro" element={<TesouroDiretoDashboard />} />
                    <Route path="/investments/list" element={<InvestmentsList />} />
                    <Route path="/investments/edit" element={<EditInvestments />} />
                    <Route path="/investments/import" element={<ImportInvestments />} />
                    <Route path="/investments/import/stock" element={<StockImport />} />
                    <Route path="/investments/import/digital-coin" element={<DigitalCoinImport />} />
                    <Route path="/investments/import/tesouro-direto" element={<TesouroDiretoImport />} />
                    <Route path="/investments/clear" element={<ClearInvestments />} />
                    {/* goals */}
                    <Route path="/goals" element={<Goals />} />
                    {/* cashflow */}
                    <Route path="/cashflow" element={<Cashflow />} />
                    <Route path="/cashflow/edit" element={<EditCashflow />} />
                    {/* account */}
                    <Route path="/account" element={<Account />} />
                    {/* dashboard */}
                    <Route path="/dashboard" element={<Dashboard />} />
                  </Routes>
                </main>
                </div>
            </div>
          </ProtectedRoute>
        } />
      </Routes>
      <Toaster />
    </Router>
  );
};

export default App;

